<template lang="pug">
div.row
    div.col-xs-12.variants(
        v-for="(ingredient, index) in product.ingredients"
        :key="index"
    )
        div(:class="{ 'col-xs-6': hasMultipleIngredient, 'col-xs-7': !hasMultipleIngredient }")
            div.md-form-group.p-t-0
                label.typo__label.multiselect-label.font-sm Ingredient
                multiselect(
                    track-by="id"
                    label="name"
                    :options="ingredientList"
                    :loading="onLoading('fetch-ingredients')"
                    v-model="ingredient.ingredient"
                    :allow-empty="false"
                    v-validate="'required'"
                    :data-vv-scope="`ingredient_${index}`"
                    @search-change="loadIngredients"
                    @open="open()"
                    @close="close()"
                )
                span.small.text-danger(v-if="errors.has(`ingredient_${index}`)")
                    | {{ errors.first(`ingredient_${index}`) }}

        div.col-xs-3
            div.md-form-group
                input.md-input.m-t-1.small(
                    v-model="ingredient.ingredient.uom"
                    disabled
                )
                label Measurement

        div.col-xs-2
            div.md-form-group
                input.md-input.m-t-1(
                    type="number"
                    v-model="ingredient.portion"
                    min="0"
                    step="any"
                    required
                )
                label Portion (#)

        div.col-xs-1(v-if="hasMultipleIngredient")
            i.text-muted.material-icons.md-18.btn-del-list.pointer.m-t-md(
                @click="removeIngredient(index)"
            ) &#xe14c;

    div.col-xs-12.text-right.m-t-sm.p-b-3
        button.btn.btn-outline.btn-sm.rounded.b-success.text-success(
            type="button"
            @click="addIngredient()"
        )
            i.material-icons.md-18 &#xe145;
            | Add Recipes
</template>

<script>
import ingredientStoreMixin from '../../inventory-fnb/ingredient/store-mixin';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import handleValidatorUI from '@js/mixins/handle-validator-ui';

export default {
    inject: ['$validator'],

    mixins: [ingredientStoreMixin, handleValidatorUI],

    props: {
        product: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            hasValidationError: false,
        };
    },

    computed: {
        ...mapGetters('ingredient', [
            'ingredientList',
            'originalIngredientList',
        ]),

        hasMultipleIngredient() {
            return this.product.ingredients.length > 1;
        },

        productIngredients() {
            return this.product.ingredients;
        },
    },

    mounted() {
        if (_.isEmpty(this.ingredientList)) {
            this.loadIngredients();
        }
    },

    methods: {
        ...mapActions('ingredient', ['getIngredientList']),

        ...mapMutations('ingredient', ['setIngredientList']),

        addIngredient() {
            let ingredient = {
                id: null,
                portion: null,
                ingredient: {
                    id: null,
                    uom: null,
                },
            };

            this.product.ingredients.push(ingredient);
        },

        removeIngredient(index) {
            this.product.ingredients.splice(index, 1);
        },

        validate() {
            this.hasValidationError = false;

            this.product.ingredients.map((ingredient, index) => {
                this.validateField(
                    ingredient.ingredient.id,
                    `ingredient_${index}`,
                    'ingredient',
                );
            });
        },

        loadIngredients: _.debounce(function(query = '') {
            const params = {
                query,
                outlet_id: this.product.outlet_id,
                mergeIds: this.getExistingIngredientIds(),
            };

            this.getIngredientList(params);
        }, 500),

        open() {
            const mergeIds = this.getExistingIngredientIds();

            const data = this.originalIngredientList.filter(
                i => !mergeIds.includes(i.id),
            );

            this.setIngredientList(data);
        },

        close() {
            this.setIngredientList(this.originalIngredientList);
        },

        getExistingIngredientIds() {
            let variants = this.product.variants;
            let variantRecipes = _.flatten(_.map(variants, 'ingredients'));
            let variantIngredients = _.map(variantRecipes, 'ingredient');

            let productIngredients = _.map(
                this.product.ingredients,
                'ingredient',
            );

            let vIds = _.map(variantIngredients, 'id');
            let pIds = _.map(productIngredients, 'id');

            return [...vIds, ...pIds];
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/main-ingredient.vue